// @flow

import DashboardHeader from './DashboardHeader'

export default DashboardHeader
